import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import NumberCard from "@/components/custom/NumberCard";
import CardWarnIcon from "@/assets/icons/CarWarnIcon.svg";
import WifiOffIcon from "@/assets/icons/WifiOffIcon.svg";
import ButtonCard from "@/components/custom/ButtonCard";
import CarIcon from "@/assets/icons/CarIcon.svg";
import { useTheme } from "@/themeConfigs/ThemeContext";
import DashboardService from "@/services/api/DashboardService";
import { CarStatusDashboardResponse } from "@/central-atoms/everest-fleet-pwa/responses";
import { setCarStatus } from "@/redux/carStatusSlice";

interface CarStatusTabProps {
  hubName: string;
}

const CarStatusTab: React.FC<CarStatusTabProps> = ({ hubName }) => {
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const [carStatusDashboard, setCarStatusDashboard] =
    useState<CarStatusDashboardResponse | null>(null);

  useEffect(() => {
    const fetchCarStatusDashboard = async () => {
      try {
        const data = await DashboardService.getCarStatusDashboard(hubName);
        setCarStatusDashboard(data);
        dispatch(setCarStatus(data.data.data.car_status));
      } catch (error) {
        console.error("Failed to fetch car status dashboard", error);
      }
    };

    fetchCarStatusDashboard();
  }, [hubName, dispatch]);

  if (!carStatusDashboard) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="grid grid-cols-2 mt-4 gap-x-2">
        <NumberCard
          number={carStatusDashboard.data.data.car_status.pending_repair}
          text="Pending Repair"
          icon={CardWarnIcon}
        />
        <NumberCard
          number={carStatusDashboard.data.data.car_status.obd_unplugged}
          text="MMI Unplugged"
          icon={WifiOffIcon}
        />
      </div>
      <div className="pt-4 flex flex-col gap-y-4">
        <ButtonCard
          color={theme.colors.secondary}
          icon={CarIcon}
          text="Cars Allotted Today"
          number={carStatusDashboard.data.data.car_status.cars_allotted_today}
          navigateTo="/cars-allocated"
        />
        <ButtonCard
          color={theme.colors["supervisor-red"]}
          icon={CarIcon}
          text="Idle for more than 45 mins"
          number={carStatusDashboard.data.data.car_status.idle_cars.forty_five_min}
          navigateTo="/idle"
          queryParam="45"
        />
        <ButtonCard
          color={theme.colors["supervisor-orange"]}
          icon={CarIcon}
          text="Idle for more than 30 mins"
          number={carStatusDashboard.data.data.car_status.idle_cars.thirty_min}
          navigateTo="/idle"
          queryParam="30"
        />
        <ButtonCard
          color={theme.colors["supervisor-yellow"]}
          icon={CarIcon}
          text="Idle for more than 15 mins"
          number={carStatusDashboard.data.data.car_status.idle_cars.fifteen_min}
          navigateTo="/idle"
          queryParam="15"
        />
      </div>
    </>
  );
};

export default CarStatusTab;
